import React from 'react';
import { Heading, Stack } from '@global-ecom/nitro-uds/elements';

import { useFeature } from 'hooks/useFeature';

export const MyAccountHeader: React.FC<{
  title: string;
  subtitle?: string;
}> = ({ title, subtitle }) => {
  const hideMyAccountSubtitle = useFeature('HIDE_MY_ACCOUNT_SUBTITLE');

  return (
    <Stack items="start">
      <Stack gap="xs" items="start" asChild>
        <p>
          <Heading className="order-2" size={{ _: 'xl', md: '3xl' }} asChild>
            <span>{title}</span>
          </Heading>
          {subtitle && !hideMyAccountSubtitle ? (
            <Heading className="order-1" size={{ _: 'xs', md: 'base' }} asChild>
              <span>{subtitle}</span>
            </Heading>
          ) : null}
        </p>
      </Stack>
    </Stack>
  );
};
